export const COST_CALCULATOR_LINK =
  "https://docs.google.com/spreadsheets/d/1N5RYTHrEsQBhKDdrxtLXOtmycJ4s1tET2neWTS3f6Y8/edit?gid=0#gid=0";
